import React, { useEffect, useState } from "react";
import logo from "../Images/Group 1171279193.png";
import { NavLink, useNavigate } from "react-router-dom";
import tick from "../Images/Frame 1991425400 (1).png";
import plus from "../Images/fi_2801881 (1).png";
import disable from "../Images/Frame 1991425400 (2).png";
import heart from "../Images/fi_3641323.png";
import myCommunity from "../Images/users-solid.svg";

import comments from "../Images/fi_3641323 (1).png";
import price from "../Images/Frame 1991425400 (3).png";
import profile from "../Images/Frame 1991425400 (4).png";
import locality from "../Images/Frame 1991425400 (5).png";
import subLocality from "../Images/Frame 1991425400 (6).png";
import logout from "../Images/Frame 1991425400 (7).png";
import logo2 from "../Images/darklogo.png";
import logown from "../Images/logown.png";
import HomeService from "../Services/HomeService";
import { toast } from "react-toastify";
const Sidebar = ({ collapse }) => {
  const [loginProfile, setLoginProfile] = useState(false);
  const [dealerDetails, setDealerDetails] = useState({});

  const getLoginProfile = async () => {
    const res = await HomeService.getLoginProfile();
    if (res.status) {
      setLoginProfile(res.data);
    }
  };

  const handleLogOut = async () => {
    try {
      const res = await HomeService.handleUserLogout();
      if (res.status) {
        toast.success(res.message);
        // toast.success(
        //   `Your Max Device Limit is : ${res?.data?.maxDeviceLimit} & Active Device is : ${res?.data?.remainingDevices}`
        // );

      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
    localStorage.removeItem("token");
    setLoginProfile(false);
    window.location.reload();
  };

  const dealerDetail = async () => {
    try {
      const res = await HomeService.getAllAdvertisement(loginProfile?._id);

      if (res.status) {
        const data = res.data.find(
          (item) => item?.userId === loginProfile?._id,
        );
        setDealerDetails(data);
      } else {
        console.error("Invalid response format:", res);
      }
    } catch (error) {
      console.error("Error fetching dealer details:", error);
    }
  };

  const navigate = useNavigate();

  const handleNavigateDealer = async () => {
    try {
      const res = await HomeService.getAllAdvertisement(loginProfile?._id);

      if (res.status) {
        const data = res.data.find(
          (item) => item?.userId === loginProfile?._id,
        );

        if (data) {
          setDealerDetails(data);

          navigate("/communitylist", {
            state: {
              dealerDetails: data,
              showInnerState: false,
            },
          });
        } else {
          console.warn("Dealer details not found.");
        }
      } else {
        console.error("Invalid response format:", res);
      }
    } catch (error) {
      console.error("Error fetching dealer details:", error);
    }
  };

  useEffect(() => {
    dealerDetail();
  }, [loginProfile]);

  useEffect(() => {
    getLoginProfile();
  }, []);
  return (
    <>
      <div className={collapse ? "layout_collapsed" : ""}>
        <div className="sidebar_main_div">
          <div className="sidebar_logo_wrapper d-flex justify-content-center">
            <div
              className="sidebar_logo_img"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/");
              }}
            >
               <img className="logo-light" src={logo} alt="logo" />
              <img className="logo-dark" src={logown
                
              } alt="logo" />
            </div>
          </div>

          <div className="sidebar_icons_div_wrapper">
            <div
              style={{
                rowGap: "20px",
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            >
              <NavLink to={"/propertylist"} className="sidebar_icons_wrapper">
                <img className="icon_img" src={tick}></img>
                <NavLink to={"/propertylist"} className="sidebar_icons">
                  All Confirm Data
                </NavLink>
              </NavLink>

              <NavLink to={"/new-properties"} className="sidebar_icons_wrapper">
                <img className="icon_img" src={plus}></img>
                <NavLink to={"/new-properties"} className="sidebar_icons">
                  Newly Added Data
                </NavLink>
              </NavLink>

              <NavLink
                to={"/deactive-properties"}
                className="sidebar_icons_wrapper"
              >
                <img className="icon_img" src={disable}></img>
                <NavLink to={"/deactive-properties"} className="sidebar_icons">
                  De active Data
                </NavLink>
              </NavLink>

              <NavLink
                to={"/list-of-favourites"}
                className="sidebar_icons_wrapper"
              >
                <img className="icon_img" src={heart}></img>
                <NavLink to={"/list-of-favourites"} className="sidebar_icons">
                  List of Favourites
                </NavLink>
              </NavLink>

              <NavLink
                to={{
                  pathname: "/communitylist",
                }}
                className="sidebar_icons_wrapper"
                onClick={handleNavigateDealer}
              >
                <img className="icon_img" src={myCommunity}></img>
                <NavLink
                  to={{
                    pathname: "/communitylist",
                  }}
                  className="sidebar_icons"
                >
                  My Community
                </NavLink>
              </NavLink>
              <NavLink
                to={"/community-fav-list"}
                className="sidebar_icons_wrapper"
              >
                <img className="icon_img" src={heart}></img>
                <NavLink to={"/community-fav-list"} className="sidebar_icons">
                  Favourite Communities
                </NavLink>
              </NavLink>

              {/* <NavLink to={"/cd"} className="sidebar_icons_wrapper">
                  <img className="icon_img" src={comments}></img>
                  <NavLink to={"/cd"} className="sidebar_icons">
                    Comments
                  </NavLink>
                </NavLink> */}

              <NavLink to={"/pricingplan"} className="sidebar_icons_wrapper">
                <img className="icon_img" src={price}></img>
                <NavLink to={"/pricingplan"} className="sidebar_icons">
                  Price List
                </NavLink>
              </NavLink>

              <NavLink to={"/profile"} className="sidebar_icons_wrapper">
                <img className="icon_img" src={profile}></img>
                <NavLink to={"/profile"} className="sidebar_icons">
                  Profile
                </NavLink>
              </NavLink>

              {/* <NavLink to={"/cd"} className="sidebar_icons_wrapper">
                  <img className="icon_img" src={locality}></img>
                  <NavLink to={"/cd"} className="sidebar_icons">
                    Locality Wise Data
                  </NavLink>
                </NavLink> */}

              {/* <NavLink to={"/cd"} className="sidebar_icons_wrapper">
                  <img className="icon_img" src={subLocality}></img>
                  <NavLink to={"/cd"} className="sidebar_icons">
                    Sub Locality
                  </NavLink>
                </NavLink> */}

              <NavLink to={"/profile"} className="sidebar_icons_wrapper">
                <img className="icon_img" src={logout}></img>
                <NavLink
                  to={"/profile"}
                  className="sidebar_icons"
                  onClick={handleLogOut}
                >
                  {loginProfile ? "Logout" : "Login"}
                </NavLink>
              </NavLink>
            </div>

            {/* <div className="sidebar_upgrade_now_div_wrapper d-flex justify-content-center align-items-center">
                <div className="sidebar_upgrade_now_div">
                  <h5 className="sidebar_upgrade_now_head">UPGRADE NOW</h5>
                  <p className="sidebar-premium-text">Get Premium Community</p>
                  <div
                    className="d-flex justify-content-center"
                    style={{ marginTop: "35px" }}
                  >
                    <button className="sidebar_upgrade_button">Upgrade Now</button>
                  </div>
                </div>
              </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
